import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostCommentsSucceed, EGetPostCommentsActionType } from './types';
import { ICommentList } from '../../../types/commentList';

export const getPostCommentsSucceed: (data: ICommentList) => TGetPostCommentsSucceed = actionGenerator<
  EGetPostCommentsActionType.Succeed,
  ICommentList
>(EGetPostCommentsActionType.Succeed);
